import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@ng-cds/ui-components/loader';
import { ProgressLoaderComponent } from '@ng-cds/ui-components/progress-loader';
import { ConfirmationDialogComponent } from '@ng-cds/ui-components/confirmation-dialog';

@Component({
  standalone: true,
  imports: [RouterModule, LoaderComponent, ProgressLoaderComponent, ConfirmationDialogComponent],
  selector: 'vallia-doc-flow-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'vallia-doc-flow';
}
